/**
 * Returns an axios headers object with Bearer token if info is present.
 * Usage: authHeader(userInfo) or authHeader(ownerInfo)
 */
export const authHeader = (info) => ({
  'Content-Type': 'application/json',
  ...(info?.token ? { Authorization: `Bearer ${info.token}` } : {})
})
